import { render, staticRenderFns } from "./AbstractFormPage.vue?vue&type=template&id=16f2c58c"
import script from "./AbstractFormPage.vue?vue&type=script&lang=js"
export * from "./AbstractFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports